import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import { FontWeights, Typography } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Header = styled.h1`
  ${Typography.M};
  ${FontWeights.Medium};

  text-align: center;
  color: ${Colors.Neutral90};
`

export const SubHeader = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};

  text-align: center;
  color: ${Colors.Neutral50};
`
